import { render, staticRenderFns } from "./floorMenuItem.vue?vue&type=template&id=3a114328&"
import script from "./floorMenuItem.vue?vue&type=script&lang=js&"
export * from "./floorMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports